import type { ReactElement } from "react";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import { ButtonPreset } from "@/constants/componentPresets";
import { Cbutton } from "../Cbutton";
import type { ScrollHintState } from "./useKanbanBoardScroll";

interface KanbanNavigationControlsProps {
  scrollHintState: ScrollHintState;
  handleScrollToPrevColumn: () => void;
  handleScrollToNextColumn: () => void;
}

export function KanbanNavigationControls({
  scrollHintState,
  handleScrollToPrevColumn,
  handleScrollToNextColumn,
}: KanbanNavigationControlsProps): ReactElement {
  return (
    <>
      <Cbutton
        preset={ButtonPreset.Ghost}
        rootAttributes={{ "data-el": "Cmarkdownkanban/NavigationControls/PreviousTrigger" }}
        icon={IconChevronLeft}
        iconSize={20}
        padding={6}
        disabled={!scrollHintState.showLeft}
        onClick={handleScrollToPrevColumn}
      />
      <Cbutton
        preset={ButtonPreset.Ghost}
        rootAttributes={{ "data-el": "Cmarkdownkanban/NavigationControls/NextTrigger" }}
        icon={IconChevronRight}
        iconSize={20}
        padding={6}
        disabled={!scrollHintState.showRight}
        onClick={handleScrollToNextColumn}
      />
    </>
  );
}

export function getKanbanNavigationControls(
  input: KanbanNavigationControlsProps,
): ReactElement | undefined {
  const showNavigationButtons =
    input.scrollHintState.showLeft || input.scrollHintState.showRight;

  if (!showNavigationButtons) {
    return undefined;
  }

  return <KanbanNavigationControls {...input} />;
}
